/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Stock_MovementsInputs */

const en_nav_stock_movements = /** @type {(inputs: Nav_Stock_MovementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stock movements`)
};

/**
* | output |
* | --- |
* | "Stock movements" |
*
* @param {Nav_Stock_MovementsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_stock_movements = /** @type {((inputs?: Nav_Stock_MovementsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Stock_MovementsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_stock_movements(inputs)
});